<template>
  <div class="page-main">
    <page-title :back="true" @goback="goback" />
    <page-card style="margin-bottom:32px" v-loading="loading">
      <template slot="header">
        Add users
      </template>
      <div slot="body">
        <el-form :model="form" ref="form" label-width="150px">
          <el-row :gutter="10" v-for="(item, index) in form.list" :key="item.key" style="margin-bottom:10px;">
            <el-col :span="12">
              <el-form-item :prop="'list.' + index + '.account'" label="User account:" :rules="[
                  { required: true, message: 'User account cannot be empty', trigger: ['blur', 'change'] },
                  { validator: checkAddress, trigger: ['blur', 'change'] }
                ]">
                <el-input v-model="item.account"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item :prop="'list.' + index + '.ratio'" label="Receive ratio:" :rules="[
                  { required: true, message: 'Receive ratio cannot be empty', trigger: ['blur', 'change'] },
                  { validator: checkRatio, trigger: ['blur', 'change'] },
                ]">
                <el-input v-model="item.ratio">
                  <template slot="append">%</template>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="2">
              <el-button type="text" icon="el-icon-delete" @click="handleDel(index)">
              </el-button>
            </el-col>
          </el-row>
        </el-form>
        <div class="btns">
          <el-button class="morebtn" @click="handleAdd">add more</el-button>
          <el-button @click="goback">Cancel</el-button>
          <el-button :loading="btnLoading" type="primary" @click="handleCheck">Submit</el-button>
        </div>

      </div>
    </page-card>
    <!-- 0x7f068e25267c7b8c620a5664c52ea5C37Fd007d9
    0x1935Ec033dc8F0dDD958E8CaaD8C530AAC4230aF -->
    <el-dialog class="msgDio" :visible.sync="open" width="5rem" center>
      <div><b>Submit successfully！</b></div>
      <div>Please complete the multi-signature execution as soon as possible！</div>
      <div>Proposal ID：{{ proposalId }}
        <el-button type="text" v-clipboard:copy="`${proposalId}`" v-clipboard:success="onCopy">Copy</el-button>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="goback">Confirm</el-button>
      </span>
    </el-dialog>

    <ErrorMsg ref="ErrorMsg"></ErrorMsg>
  </div>
</template>

<script>
import BigNumber from 'bignumber.js'
export default {
  data() {

    return {
      loading: false,
      btnLoading: false,
      contract: null,
      contractAddress: null,
      form: {
        list: [{
          key: Date.now(),
          account: '',
          ratio: '',
        }],
      },
      proposalId: null,
      open: false,
    };
  },
  mounted() {
    this.getAbi('AirDrop').then(res => {
      let myAddress = process.env.VUE_APP_CONTRACT_ADDRESS ? process.env.VUE_APP_CONTRACT_ADDRESS : res.result.address
      this.contract = new web3.eth.Contract(res.result.abi, myAddress);
      this.contractAddress = myAddress;
    })
  },
  methods: {
    goback() {
      this.$router.back()
    },
    handleAdd() {
      this.form.list.push({
        key: Date.now(),
        account: '',
        ratio: '',
      })
    },
    handleDel(index) {
      this.form.list.splice(index, 1)
    },
    handleCheck() {
      let validateArr = [], errorArr = []
      this.form.list.forEach((item, index) => {
        validateArr.push(`list.${index}.account`)
        validateArr.push(`list.${index}.ratio`)
      })
      this.$refs.form.validateField(validateArr, (errorMsg) => {
        console.log(errorMsg)
        if (errorMsg) {
          errorArr.push(errorMsg)
        }
        console.log(errorArr)
      });
      if (errorArr.length === 0) {
        let total = this.form.list.reduce((pre, cur) => {
          let pval = new BigNumber(pre)
          pval.plus(Number(cur.ratio))
        }, 0);
        let nums = new BigNumber(100)
        if (total > (nums.minus(Number(this.$route.query.allRatio)))) {
          this.$message.warning(`The total receive ratio cannot exceed ${100 - this.$route.query.allRatio}`)
          return false;
        }
        this.handleSubmit()
      }
    },
    handleSubmit() {
      this.btnLoading = true
      let accountList = []
      let ratioList = []
      this.form.list.forEach(item => {
        accountList.push(item.account)
        ratioList.push( this.getRatioVal(item.ratio))
      })
      console.log(accountList, ratioList)
      const tx_builder = this.contract.methods["propose"](
        0,
        accountList,
        ratioList
      );
      const encoded_tx = tx_builder.encodeABI();

      let json = {
        gas: this.$store.getters.gas,
        from: this.$store.getters.metaMaskObj.account,
        to: this.contractAddress,
        value: 0,
        data: encoded_tx,
      };
      web3.eth
        .sendTransaction(json)
        .then((res) => {
          setTimeout(this.getProposalId(res.blockNumber), 10000)
        })
        .catch((error) => {
          console.error(error);
          if (error.code === 4001) {
            this.$message.error(error.message)
          } else {
            this.$refs.ErrorMsg.show(error.receipt.blockNumber)
          }
          this.btnLoading = false;
        });
    },
    getRatioVal(val) {
      let r = new BigNumber(val)
      return  r.multipliedBy(1000000).toString()
    },
    async getProposalId(blockNumber) {
      try {
        const arr = await this.contract.getPastEvents('SendProposal', {
          fromBlock: blockNumber,
          toBlock: blockNumber
        });
        arr.forEach(item => {
          if (item.returnValues.proposer.toLowerCase() === this.$store.getters.metaMaskObj.account.toLowerCase()) {
            this.proposalId = item.returnValues.proposalId
          }
        })
        this.btnLoading = false;
        this.open = true
      }
      catch (error) {
        if (error.code === 4001) {
          this.$message.error(error.message)
        } else {
          this.$refs.ErrorMsg.show(error.receipt.blockNumber)
        }
        this.btnLoading = false;
      }
    },
    onCopy() {
      this.$message.success('Copy successfully!')
    },
    checkAddress(rule, value, callback) {
      if (!web3.utils.isAddress(value)) {
        return callback(new Error('Invalid address'));
      }
    },
    checkRatio(rule, value, callback) {
      let reg = /^(?=.*[0-9])\d{0,3}(?:\.\d{0,6})?$/
      if (!reg.test(value)) {
        return callback(new Error(`Please enter an integer or a decimal with no more than 6 decimal places`));
      }
      if (Number(value) < 0 || Number(value) > 100) {
        return callback(new Error('Please enter a number between 0 and 100'));
      }
    }
  },
};
</script>
<style scoped lang="scss">
.msgDio {

  /deep/ .el-dialog__header {
    border-bottom: 0;
  }

  div {
    text-align: center;
    line-height: 30px;
  }
}

.btns {
  text-align: center;
}
</style>
